import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { cardTitle, grayColor } from "assets/jss/elite-feats-cms";

const userProfileStyles: Record<string, CSSProperties> = {
  cardTitle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
    marginLeft: -90,
    "& small": {
      fontSize: "80%",
      fontWeight: 400,
    },
  },
  cardCategory: {
    marginTop: "10px",
    color: grayColor[0] + " !important",
    textAlign: "center",
  },
  description: {
    color: grayColor[0],
  },
  updateProfileButton: {
    float: "right",
  },
  option: {
    fontSize: 15,
    "& > span": {
      marginRight: 10,
      fontSize: 18,
    },
  },
};
export default userProfileStyles;
